import React from "react";
import { Route, Navigate } from "react-router-dom";
const routes = all_routes;
import { all_routes } from "./all_routes";
//region icons
import FontawesomeIcons from "../feature-module/uiinterface/icons/fontawesome";
import FeatherIcons from "../feature-module/uiinterface/icons/feathericon";
import IonicIcons from "../feature-module/uiinterface/icons/ionicicons";
import MaterialIcons from "../feature-module/uiinterface/icons/materialicon";
import PE7Icons from "../feature-module/uiinterface/icons/pe7icons";
import SimplelineIcons from "../feature-module/uiinterface/icons/simplelineicon";
import ThemifyIcons from "../feature-module/uiinterface/icons/themify";
import WeatherIcons from "../feature-module/uiinterface/icons/weathericons";
import TypiconIcons from "../feature-module/uiinterface/icons/typicons";
import FlagIcons from "../feature-module/uiinterface/icons/flagicons";
import BootstrapIcons from "../feature-module/uiinterface/icons/bootstrapicons";
import RemixIcons from "../feature-module/uiinterface/icons/remixIcons";
import TablerIcon from "../feature-module/uiinterface/icons/tablericon";
import LayoutDemo from "../feature-module/layout-pages/layoutdemo";

//region auth
import Signin from "../feature-module/pages/login/signin";
import Forgotpassword from "../feature-module/pages/forgotpassword/forgotpassword";

//region Pereco

//region rollcall
import RollcallDashboard from "./../feature-module/Pereco/RollCall/Dashboard/Dashboard";
import RegistrationsList from "../feature-module/Pereco/RollCall/Registartions/Registrations";
import RejoinEmployeeList from "../feature-module/Pereco/RollCall/RejoinEmployees/RejoinEmployees";
import RollcallEmployeesList from "../feature-module/Pereco/RollCall/Employees/Employees";
import RollcallAdditionalDetails from "../feature-module/Pereco/RollCall/AdditionalDetails/AdditionalDetails";
import RollcallManualAttendanceList from "../feature-module/Pereco/RollCall/ManualAttendance/ManualAttendance";
import RollcallHolidaysList from "../feature-module/Pereco/RollCall/Configurations/Holidays/Holidays";
import RollcallDepartmentList from "../feature-module/Pereco/RollCall/Configurations/Department/Departments";
import RollcallEmployeeAccess from "../feature-module/Pereco/RollCall/Configurations/EmployeeAccess/EmployeeAccess";
import RollcallAssignShifts from "../feature-module/Pereco/RollCall/AssignShifts/AssignShifts";
import RollCallLeaves from "../feature-module/Pereco/RollCall/Leaves/Leaves";
import RollcallReports from "../feature-module/Pereco/RollCall/Reports/RollcallReports";
import LeaveAccurals from "../feature-module/Pereco/RollCall/Leaves/LeaveAccurals";
import LeaveSummary from "../feature-module/Pereco/RollCall/Leaves/LeaveSummary";
import RollcallLeaveTypes from "../feature-module/Pereco/RollCall/Configurations/LeaveTypes/LeaveTypes";
import RollcallNotification from "../feature-module/Pereco/RollCall/Dashboard/notification";
import ProtectedRoute from "../feature-module/Pereco/RollCall/Dashboard/protectedroute";
import Permissions from "../feature-module/Pereco/RollCall/Permissions/Permissions";
import Salaries from "../feature-module/Pereco/RollCall/Employees/Salaries";
import EmployeeProfile from "../feature-module/Pereco/RollCall/Profile/Profile";
import Employee_Anual_CTC from "../feature-module/Pereco/Payroll/PayrollConfig/Employee_Anual_CTC";
import SalaryAdvance from "../feature-module/Pereco/Payroll/Salary/SalaryAdvance";
import SalaryList from "../feature-module/Pereco/Payroll/Salary/SalaryList";
import AdvanceAdjustment from "../feature-module/Pereco/Payroll/Salary/AdvanceAdjustment";
import FixedIncentives from "../feature-module/Pereco/Payroll/Salary/FixedIncentives";
import PayrollDashboard from "../feature-module/Pereco/Payroll/Dashboard/Dashboard";
import CombinedProcessPayroll from "../feature-module/Pereco/Payroll/PayRoll/CombinedProcessPayroll";
import ProcessPayroll from "../feature-module/Pereco/Payroll/PayRoll/ProcessPayroll";
import PaySlip from "../feature-module/Pereco/Payroll/PayRoll/PaySlip";
import PayList from "../feature-module/Pereco/Payroll/Expenses/PayList";
import PayrollReports from "../feature-module/Pereco/Payroll/Reports/PayrollReports";
import LastThreeMonthsPaySlip from "../feature-module/Pereco/Payroll/PayRoll/Lastthreemonthspayslip";
import GroupPayrollReports from "../feature-module/Pereco/Payroll/Reports/GroupPayrollReports";
// import Employee_Anual_CTC from "../feature-module/Pereco/RollCall/Payroll/PayrollConfig/Employee_Anual_CTC";
// import SalaryAdvance from "../feature-module/Pereco/RollCall/Payroll/Salary/SalaryAdvance";
// import SalaryList from "../feature-module/Pereco/RollCall/Payroll/Salary/SalaryList";
// import AdvanceAdjustment from "../feature-module/Pereco/RollCall/Payroll/Salary/AdvanceAdjustment";
// import FixedIncentives from "../feature-module/Pereco/RollCall/Payroll/Salary/FixedIncentives";
// import PayrollDashboard from "../feature-module/Pereco/RollCall/Payroll/Dashboard/Dashboard";
// import ProcessPayroll from "../feature-module/Pereco/RollCall/Payroll/PayRoll/ProcessPayroll";
// import PayList from "../feature-module/Pereco/RollCall/Payroll/Expenses/PayList";
// import PaySlip from "../feature-module/Pereco/RollCall/Payroll/PayRoll/PaySlip";
// import CombinedProcessPayroll from "../feature-module/Pereco/RollCall/Payroll/PayRoll/CombinedProcessPayroll";
export const publicRoutes = [
  {
    id: 49,
    path: routes.fontawesome,
    name: "fontawesome",
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: "feathericon",
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: "ionicicons",
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: "materialicons",
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: "pe7icons",
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: "simpleline",
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: "themifyicon",
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: "iconweather",
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: "typicons",
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: "flagicons",
    element: <FlagIcons />,
    route: Route,
  },

  {
    id: 106,
    path: routes.remixIcon,
    name: "remixIcon",
    element: <RemixIcons />,
    route: Route,
  },
  {
    id: 107,
    path: routes.BootstrapIcon,
    name: "BootstrapIcon",
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    id: 108,
    path: routes.TablerIcon,
    name: "TablerIcon",
    element: <TablerIcon />,
    route: Route,
  },

  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: "/",
    name: "Root",
    element: <Navigate to="/signin" />,
    route: Route,
  },

  {
    id: 162,
    path: routes.Horizontal,
    name: "layout-horizontal",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 163,
    path: routes.Detached,
    name: "layout-detached",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 164,
    path: routes.Modern,
    name: "layout-modern",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 165,
    path: routes.TwoColumn,
    name: "layout-two-column",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 166,
    path: routes.Hovered,
    name: "layout-hovered",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 167,
    path: routes.Boxed,
    name: "layout-boxed",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 168,
    path: routes.RTL,
    name: "layout-rtl",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 169,
    path: routes.Dark,
    name: "layout-dark",
    element: <LayoutDemo />,
    route: Route,
  },

  {
    id: 202,
    path: routes.rollcalldashboard,
    name: "rollcalldashboard",
    element: (
      <ProtectedRoute>
        <RollcallDashboard />
      </ProtectedRoute>
    ),
    route: Route,
  },

  {
    id: 203,
    path: routes.rollcallregistrations,
    name: "rollcallregistrations",
    element: <RegistrationsList />,
    route: Route,
  },
  {
    id: 204,
    path: routes.rollcallrejoinemployees,
    name: "rollcallrejoinemployees",
    element: <RejoinEmployeeList />,
    route: Route,
  },
  {
    id: 205,
    path: routes.rollcallemployeeslist,
    name: "rollcallemployeeslist",
    element: <RollcallEmployeesList />,
    route: Route,
  },
  {
    id: 206,
    path: routes.rollcalladditionaldetails,
    name: "rollcalladditionaldetails",
    element: <RollcallAdditionalDetails />,
    route: Route,
  },
  {
    id: 207,
    path: routes.rollcallmanualattendance,
    name: "rollcallmanualattendance",
    element: <RollcallManualAttendanceList />,
    route: Route,
  },
  {
    id: 208,
    path: routes.rollcallholidaysList,
    name: "rollcallholidaysList",
    element: <RollcallHolidaysList />,
    route: Route,
  },
  {
    id: 209,
    path: routes.rollcalldepartmentsList,
    name: "rollcalldepartmentsList",
    element: <RollcallDepartmentList />,
    route: Route,
  },
  {
    id: 210,
    path: routes.rollcallemployeesaccessList,
    name: "rollcallemployeesaccessList",
    element: <RollcallEmployeeAccess />,
    route: Route,
  },
  {
    id: 211,
    path: routes.rollcallassignshifts,
    name: "rollcallassignshifts",
    element: <RollcallAssignShifts />,
    route: Route,
  },
  {
    id: 212,
    path: routes.rollcallreports,
    name: "rollcallreports",
    element: <RollcallReports />,
  },

  {
    id: 213,
    path: routes.rollcallleaveslist,
    name: "rollcallleaveslist",
    element: <RollCallLeaves />,
    route: Route,
  },

  {
    id: 214,
    path: routes.rollcallleaveaccurals,
    name: "rollcallleaveaccurals",
    element: <LeaveAccurals />,
    route: Route,
  },
  {
    id: 215,
    path: routes.rollcallleavesummary,
    name: "rollcallleavesummary",
    element: <LeaveSummary />,
    route: Route,
  },
  {
    id: 216,
    path: routes.rollcallleavetypes,
    name: "rollcallleavetypes",
    element: <RollcallLeaveTypes />,
    route: Route,
  },
  {
    id: 217,
    path: routes.rollcallnotification,
    name: "rollcallnotification",
    element: <RollcallNotification />,
    route: Route,
  },
  {
    id: 218,
    path: routes.rollcallpermissions,
    name: "rollcallpermissions",
    element: <Permissions />,
    route: Route,
  },
  {
    id: 220,
    path: routes.rollcallsalaries,
    name: "rollcallsalaries",
    element: <Salaries />,
    route: Route,
  },

  //region payroll
    {
    id: 221,
    path: routes.payrollemployeeCTC,
    name: "payrollemployeeCTC",
    element: <Employee_Anual_CTC/>,
    route: Route,
  },
  {
    id: 222,
    path: routes.payrollsalaries,
    name: "payrollsalaries",
    element: <SalaryAdvance/>,
    route: Route,
  },
     {
    id: 223,
    path: routes.payrollsalarylist,
    name: "payrollsalarylist",
    element: <SalaryList/>,
    route: Route,
  },
   {
    id: 224,
    path: routes.payrollAdvanceAdjustment,
    name: "payrolladvanceadjustment",
    element: <AdvanceAdjustment/>,
    route: Route,
  },
     {
    id: 225,
    path: routes.payrollFixedIncentives,
    name: "payrollfixedincentives",
    element: <FixedIncentives/>,
    route: Route,
  },
       {
    id: 225,
    path: routes.payrollDashboard,
    name: "payrollDashboard",
    element: <PayrollDashboard/>,
    route: Route,
  },
  {
    id: 226,
    path: routes.payrollimportattendence,
    name: "payrollimportattendence",
    element: <CombinedProcessPayroll/>,
    route: Route,
  },
     {
    id: 227,
    path: routes.payrollProcessPayroll,
    name: "payrollprocesspayroll",
    element: <ProcessPayroll />,
    route: Route,
  },
      {
    id: 228,
    path: routes.payrollpaylist,
    name: "payrollpaylist",
    element: <PayList/>,
    route: Route,
  },
  {
    id: 229,
    path: routes.payrollPaySlip,
    name: "payrollpayslip",
    element: <PaySlip />,
    route: Route,
  },
    {
    id: 230,
    path: routes.payrollreports,
    name: "payrollreports",
    element: <PayrollReports />,
  },
      {
    id: 231,
    path: routes.payrolllastPaySlip,
    name: "payrolllastPaySlip",
    element: <LastThreeMonthsPaySlip/>,
  },
       {
    id: 232,
    path: routes.payrollGroupreports,
    name: "payrollGroupreports",
    element: <GroupPayrollReports/>,
  },
];

export const posRoutes = [];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
  {
    id: 8,
    path: routes.profile,
    name: "profile",
    element: <EmployeeProfile />,
    route: Route,
  },
];
